export default __webpack_public_path__ + "static/media/main.f0d7eb8b.jpg";